import { ref } from "vue";

const breakpoints = {
  xs: "450px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
};

export function useBreakPoint(breakPoint: keyof typeof breakpoints) {
  const isBreakPoint = ref(false);
  const checkBreakPoint = () => {
    isBreakPoint.value = window.innerWidth > parseInt(breakpoints[breakPoint]);
  };
  window.addEventListener("resize", checkBreakPoint);
  checkBreakPoint();
  return isBreakPoint;
}
